import { ceV2Axios } from './axios';

import { DataResponse, DefaultPaymentMethod, PageableResponse, PaymentMethod, PaymentMethodType, StripePaymentConfig } from '../models';
import { composeQuery, Query } from '../models/query';

export const getPaymentMethods = async (...criteria: Query<PaymentMethod>[]) => (await ceV2Axios.get<PageableResponse<PaymentMethod>>('/payment-methods', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: composeQuery<PaymentMethod>(...criteria),
  // must specify data to keep Content-Type header
  // though axios will remove request body when using GET method.
  data: {},
})).data.data;

export const createPaymentMethod = async (input: Required<Pick<PaymentMethod, 'accountId' | 'stripeToken'>>) => (await ceV2Axios.post<DataResponse<PaymentMethod>>('/payment-methods', input)).data.data;

// Either a stripeToken (replace the card — full re-tokenization) or name/expiration
// (in-place details update of the saved card, no card number/CVC needed).
export const updatePaymentMethod = async (
  input: Required<Pick<PaymentMethod, 'id'>> & Partial<Pick<PaymentMethod, 'stripeToken' | 'name' | 'expiration'>>,
) => (await ceV2Axios.put<DataResponse<PaymentMethod>>(`/payment-methods/${input.id}`, input)).data.data;

export const deletePaymentMethod = async (input: Required<Pick<PaymentMethod, 'id'>>) => (await ceV2Axios.delete<DataResponse<PaymentMethod>>(`/payment-methods/${input.id}`)).data.data;

export const getDefaultPaymentMethod = async () => (
  await ceV2Axios.get<DataResponse<PaymentMethodType>>('/payment-methods/default', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: {},
    data: {},
  })
).data.data;

export const updateDefaultPaymentMethod = async (input: Required<DefaultPaymentMethod>) => (
  await ceV2Axios.put<DataResponse<PaymentMethodType>>('/payment-methods/default', input)
).data.data;

export const getClientSecret = async () => (
  await ceV2Axios.get<DataResponse<StripePaymentConfig>>('/payment-methods/stripe/client-secret', {})
).data.data;
